import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getMessaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyAsTqEW5BcXvr-k_-tfPNDgZwlDaby6J8o",
  authDomain: "genesis-a0f0e.firebaseapp.com",
  projectId: "genesis-a0f0e",
  storageBucket: "genesis-a0f0e.firebasestorage.app",
  messagingSenderId: "771226376662",
  appId: "1:771226376662:web:919588c9acc4cb5a9a2c77",
  measurementId: "G-3EX67M5MTD"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const messaging = getMessaging(app);

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export { googleProvider }; 